// Akıllı CV Oluşturucu - Tekil Sohbet Akışı
// Önce temel CV oluşturulur, sonra yurt dışı ilgisi sorulur

export const SECTIONS = [
  { id: 'personal', title: 'Kişisel ve İletişim Bilgileri', phase: 'cv' },
  { id: 'experience', title: 'İş Deneyimi', phase: 'cv' },
  { id: 'education', title: 'Eğitim ve Mesleki Yeterlilik', phase: 'cv' },
  { id: 'skills', title: 'Beceriler, Sertifikalar ve Dil', phase: 'cv' },
  { id: 'cvFinish', title: 'CV Tamamla', phase: 'cv' },
  { id: 'pivot', title: 'Kariyer Hedefi', phase: 'pivot' },
  { id: 'career', title: 'Kariyer Profil Analizi', phase: 'abroad' },
  { id: 'workstyle', title: 'Çalışma Tarzı ve Operasyonel Esneklik', phase: 'abroad' },
  { id: 'visa', title: 'Göç, Vize ve Yasal Durum', phase: 'abroad' },
  { id: 'country', title: 'Ülke Seçim Bilinci', phase: 'abroad' },
  { id: 'employer', title: 'İşveren Perspektifi', phase: 'abroad' },
  { id: 'adaptation', title: 'Kültürel Uyum ve Esneklik', phase: 'abroad' },
  { id: 'certification', title: 'Eğitim, Sertifika ve Oturum Desteği', phase: 'abroad' },
];

// phase: 'cv' → herkes, 'pivot' → geçiş sorusu, 'abroad' → yurt dışı modülü
const QUESTIONS = [

  // ════════════════════════════════════════
  // TEMEL CV (herkes)
  // ════════════════════════════════════════

  // -- Kişisel Bilgiler --
  {
    id: 'greeting',
    section: 'personal',
    text: 'Merhaba! Ben isBulsun yapay zeka asistanıyım. Birlikte profesyonel bir CV oluşturacağız. Hazırsanız başlayalım!\n\nAdınızı ve soyadınızı yazın.',
    type: 'text',
    field: 'fullName',
  },
  {
    id: 'phone',
    section: 'personal',
    text: 'Telefon numaranızı uluslararası alan koduyla birlikte yazın. (Örn: +90 532 123 4567)',
    type: 'text',
    field: 'phone',
  },
  {
    id: 'email',
    section: 'personal',
    text: 'E-posta adresinizi yazın.',
    type: 'text',
    field: 'email',
  },
  {
    id: 'location',
    section: 'personal',
    text: 'Şu an yaşadığınız şehir ve ülke?',
    type: 'text',
    field: 'location',
  },
  {
    id: 'birthDate',
    section: 'personal',
    text: 'Doğum tarihiniz? (Gün/Ay/Yıl)',
    type: 'text',
    field: 'birthDate',
  },
  {
    id: 'summary',
    section: 'personal',
    text: 'Kendinizi kısaca tanıtın. Bu bilgi CV\'nizdeki profesyonel özet olarak yer alacak.\n\n(Örn: "10 yıl deneyimli usta aşçı, Türk ve İtalyan mutfağında uzman" veya "15 yıllık tır şoförü, uluslararası taşımacılık deneyimli")',
    type: 'textarea',
    field: 'summary',
  },

  // -- İş Deneyimi --
  {
    id: 'experience_1',
    section: 'experience',
    text: 'Son çalıştığınız veya halen çalıştığınız işi anlatın:\n\n- Şirket/kurum adı ve lokasyonu\n- Pozisyon/unvanınız\n- Çalışma tarihleri (başlangıç - bitiş)\n\n(Örn: "Hilton Oteli İstanbul - Kıdemli Aşçıbaşı, 2019-Devam")',
    type: 'textarea',
    field: 'experience',
  },
  {
    id: 'experience_detail',
    section: 'experience',
    text: 'Bu işteki sorumluluklarınız ve başarılarınız nelerdi? Mümkünse somut rakamlarla belirtin.\n\n(Örn: "Günlük 500 kişilik menü hazırladım", "Hatalı üretim oranını %15 düşürdüm", "8 kişilik ekibi yönettim")',
    type: 'textarea',
    field: 'experienceDetail',
  },
  {
    id: 'experience_more',
    section: 'experience',
    text: 'Başka iş deneyiminiz var mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, eklemek istiyorum', value: 'yes' },
      { label: 'Hayır, devam edelim', value: 'no' },
    ],
    field: 'hasMoreExperience',
    loop: { onValue: 'yes', jumpTo: 'experience_1' },
  },

  // -- Eğitim --
  {
    id: 'education_1',
    section: 'education',
    text: 'En son tamamladığınız eğitimi yazın:\n\n- Okul adı ve bölüm/branş\n- Eğitim düzeyi (ilkokul, lise, meslek lisesi, ön lisans, lisans, yüksek lisans)\n- Mezuniyet tarihi\n\n(Örn: "Mesleki ve Teknik Anadolu Lisesi - Yiyecek İçecek Hizmetleri, 2012")',
    type: 'textarea',
    field: 'education',
  },
  {
    id: 'vocational_cert',
    section: 'education',
    text: 'Çıraklık, kalfalık, ustalık belgesi veya ulusal mesleki yeterlilik belgeleriniz var mı? Varsa neler?',
    type: 'textarea',
    field: 'vocationalCert',
  },

  // -- Beceriler, Sertifikalar, Dil --
  {
    id: 'skills',
    section: 'skills',
    text: 'Mesleğinize özel becerilerinizi, kullandığınız araç/makine/yazılımları yazın.\n\n(Örn: "TIG/MIG kaynak, CNC torna, AutoCAD" veya "React, Node.js, Python, AWS")',
    type: 'textarea',
    field: 'skills',
  },
  {
    id: 'driverLicense',
    section: 'skills',
    text: 'Sürücü belgeniz var mı? Varsa hangi sınıflar? (B, C, D, E, forklift, ağır vasıta dahil)',
    type: 'text',
    field: 'driverLicense',
  },
  {
    id: 'certificates',
    section: 'skills',
    text: 'Sahip olduğunuz mesleki sertifikalar, lisanslar veya üyelikler var mı?\n\n(Örn: "OSHA güvenlik sertifikası, ISO 22000 gıda güvenliği, Usta Aşçı Belgesi")',
    type: 'textarea',
    field: 'certificates',
  },
  {
    id: 'english_level',
    section: 'skills',
    text: 'İngilizce seviyeniz nedir?',
    type: 'choice',
    choices: [
      { label: 'Hiç bilmiyorum', value: 'none' },
      { label: 'Temel (A1-A2)', value: 'basic' },
      { label: 'Orta (B1-B2)', value: 'intermediate' },
      { label: 'İleri (C1-C2)', value: 'advanced' },
      { label: 'Akıcı / Ana dil seviyesi', value: 'fluent' },
    ],
    field: 'englishLevel',
  },
  {
    id: 'english_exam',
    section: 'skills',
    text: 'Resmi bir yabancı dil sınavına girdiniz mi? (IELTS, TOEFL, Duolingo English Test vb.) Varsa sınavı ve skorunuzu yazın.',
    type: 'text',
    field: 'englishExam',
    condition: (a) => a.englishLevel && a.englishLevel !== 'none',
  },
  {
    id: 'other_languages',
    section: 'skills',
    text: 'İngilizce dışında bildiğiniz başka dil var mı? (Dil ve seviyesini yazın)',
    type: 'text',
    field: 'otherLanguages',
  },

  // -- CV Tamamla --
  {
    id: 'cv_name',
    section: 'cvFinish',
    text: 'CV\'nize bir isim verin.\n\n(Örn: "Aşçı CV", "Tır Şoförü CV", "Genel CV")',
    type: 'text',
    field: 'cvName',
  },

  // ════════════════════════════════════════
  // GEÇİŞ SORUSU
  // ════════════════════════════════════════
  {
    id: 'abroad_interest',
    section: 'pivot',
    text: 'CV\'niz hazır, aşağıdan kaydedebilirsiniz!\n\nBir sorum daha var: Yurt dışında (ABD veya Kanada) çalışmayı düşünüyor musunuz? Düşünüyorsanız birkaç soru daha sorup size özel bir kariyer profili ve göç rehberliği hazırlayabilirim.',
    type: 'choice',
    choices: [
      { label: 'Evet, ilgileniyorum', value: 'yes' },
      { label: 'Şimdilik hayır, CV\'m yeterli', value: 'no' },
    ],
    field: 'abroadInterest',
  },

  // ════════════════════════════════════════
  // YURT DIŞI MODÜLÜ (sadece abroadInterest === 'yes')
  // ════════════════════════════════════════

  // -- Ek kişisel bilgi --
  {
    id: 'nationality',
    section: 'career',
    text: 'Uyruğunuz / vatandaşlığınız nedir?',
    type: 'text',
    field: 'nationality',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- Kariyer Profili --
  {
    id: 'career_motivation',
    section: 'career',
    text: 'Şu anki mesleğinizi ilk kez seçerken kararınızı en çok ne etkiledi?',
    type: 'choice',
    choices: [
      { label: 'Kendi bilinçli ve tutkulu tercihim', value: 'passion' },
      { label: 'Ailemin yönlendirmesi', value: 'family' },
      { label: 'Ekonomik mecburiyet / işsizlik', value: 'necessity' },
      { label: 'Rastlantı / bilinçsiz tercih', value: 'random' },
    ],
    field: 'careerMotivation',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'career_satisfaction',
    section: 'career',
    text: 'Mevcut mesleğinizi bugün sürdürme sebebiniz nedir?',
    type: 'choice',
    choices: [
      { label: 'Gerçekten seviyorum ve tercih ediyorum', value: 'love' },
      { label: 'Geçimimi sağlamak için yapıyorum', value: 'necessity' },
      { label: 'İkisi de biraz', value: 'mixed' },
    ],
    field: 'careerSatisfaction',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'career_redo',
    section: 'career',
    text: 'Kariyerinizi sıfırdan tasarlama şansınız olsaydı, yine aynı mesleği mi seçerdiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, kesinlikle aynı meslek', value: 'same' },
      { label: 'Muhtemelen evet', value: 'probably' },
      { label: 'Hayır, farklı bir alan seçerdim', value: 'different' },
    ],
    field: 'careerRedo',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'career_unhappy',
    section: 'career',
    text: 'İşinizi yaparken kendinizi en çok ne zaman mutsuz ve verimsiz hissediyorsunuz? Bu durumun üstesinden nasıl geliyorsunuz?',
    type: 'textarea',
    field: 'careerUnhappy',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- Çalışma Tarzı --
  {
    id: 'work_environment',
    section: 'workstyle',
    text: 'Hangi çalışma ortamlarında deneyiminiz var ve hangisini tercih edersiniz?',
    type: 'choice',
    choices: [
      { label: 'Açık saha / şantiye', value: 'field' },
      { label: 'Fabrika / üretim', value: 'factory' },
      { label: 'Restoran / mutfak / otel', value: 'hospitality' },
      { label: 'Ofis', value: 'office' },
      { label: 'Araç içi (şoförlük)', value: 'vehicle' },
      { label: 'Uzaktan / hibrit', value: 'remote' },
    ],
    field: 'workEnvironment',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'shift_work',
    section: 'workstyle',
    text: 'Vardiyalı çalışma, gece mesaisi veya esnek çalışma saatlerine uyum sağlayabilir misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, sorun değil', value: 'yes' },
      { label: 'Tercih etmem ama gerekirse uyum sağlarım', value: 'maybe' },
      { label: 'Hayır, sabit mesai tercih ederim', value: 'no' },
    ],
    field: 'shiftWork',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'physical_fitness',
    section: 'workstyle',
    text: 'İşinizin gerektirdiği fiziksel dayanıklılık standartlarına sahip misiniz? (Ayakta çalışma, ağır kaldırma vb.)',
    type: 'choice',
    choices: [
      { label: 'Evet, fiziksel olarak hazırım', value: 'yes' },
      { label: 'Kısmen, hafif fiziksel iş yapabilirim', value: 'partial' },
      { label: 'Hayır, masa başı tercih ederim', value: 'no' },
    ],
    field: 'physicalFitness',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'safety_training',
    section: 'workstyle',
    text: 'İş sağlığı ve güvenliği (İSG) eğitimi aldınız mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, eğitimim var ve aktif uyguluyorum', value: 'yes_active' },
      { label: 'Evet, eğitim aldım', value: 'yes' },
      { label: 'Hayır, almadım', value: 'no' },
    ],
    field: 'safetyTraining',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'stress_management',
    section: 'workstyle',
    text: 'Çok stresli veya baskı altında olduğunuz bir anda tepkinizi nasıl yönetirsiniz?',
    type: 'choice',
    choices: [
      { label: 'Sakin kalır, çözüme odaklanırım', value: 'calm' },
      { label: 'Durumu hemen netleştirmeyi tercih ederim', value: 'direct' },
      { label: 'İçime döner, sonra ele alırım', value: 'internal' },
      { label: 'Duruma göre değişir', value: 'depends' },
    ],
    field: 'stressManagement',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- Vize ve Yasal Durum --
  {
    id: 'visa_applied',
    section: 'visa',
    text: 'Daha önce Amerika veya Kanada vizesine başvurdunuz mu?',
    type: 'choice',
    choices: [
      { label: 'Evet, onaylandı', value: 'approved' },
      { label: 'Evet, reddedildi', value: 'rejected' },
      { label: 'Evet, sonuç bekliyorum', value: 'pending' },
      { label: 'Hayır, hiç başvurmadım', value: 'never' },
    ],
    field: 'visaApplied',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'visa_current',
    section: 'visa',
    text: 'Mevcut vize durumunuz nedir? Vize türünü ve geçerlilik süresini belirtin.',
    type: 'text',
    field: 'visaCurrent',
    condition: (a) => a.abroadInterest === 'yes' && a.visaApplied === 'approved',
  },
  {
    id: 'visa_reject_detail',
    section: 'visa',
    text: 'Vize reddi hangi ülke için ve hangi vize türünde gerçekleşti? Resmi gerekçe neydi?',
    type: 'textarea',
    field: 'visaRejectDetail',
    condition: (a) => a.abroadInterest === 'yes' && a.visaApplied === 'rejected',
  },
  {
    id: 'criminal_record',
    section: 'visa',
    text: 'ABD veya Kanada\'da yasal olarak çalışmanıza engel teşkil edecek adli bir sicil kaydınız var mı?',
    type: 'choice',
    choices: [
      { label: 'Hayır, temiz sicilim var', value: 'clean' },
      { label: 'Evet, detay vermek istiyorum', value: 'yes' },
    ],
    field: 'criminalRecord',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'criminal_detail',
    section: 'visa',
    text: 'Lütfen durumu kısaca açıklayın. (Bu bilgi gizli tutulacaktır)',
    type: 'textarea',
    field: 'criminalDetail',
    condition: (a) => a.abroadInterest === 'yes' && a.criminalRecord === 'yes',
  },
  {
    id: 'wait_tolerance',
    section: 'visa',
    text: 'Vize işlemleri için gereken 3-9 aylık bekleme süresini tolere edebilir misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, hazırım', value: 'yes' },
      { label: 'Zor ama yapabilirim', value: 'maybe' },
      { label: 'Hayır, hemen gitmem gerekiyor', value: 'no' },
    ],
    field: 'waitTolerance',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'migration_plan',
    section: 'visa',
    text: 'Göç planınız nasıl?',
    type: 'choice',
    choices: [
      { label: 'Yalnız gideceğim', value: 'alone' },
      { label: 'Eşimle birlikte', value: 'spouse' },
      { label: 'Ailemle birlikte (eş + çocuklar)', value: 'family' },
    ],
    field: 'migrationPlan',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'family_details',
    section: 'visa',
    text: 'Aile üyelerinin sayısı, yakınlık derecesi ve meslek durumlarını kısaca yazın.',
    type: 'textarea',
    field: 'familyDetails',
    condition: (a) => a.abroadInterest === 'yes' && a.migrationPlan && a.migrationPlan !== 'alone',
  },
  {
    id: 'financial_ready',
    section: 'visa',
    text: 'Taşınma ve ilk birkaç ay geçinme sürecini kapsayacak finansal hazırlığınız var mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, hazırım', value: 'yes' },
      { label: 'Kısmen hazırım', value: 'partial' },
      { label: 'Henüz hazır değilim', value: 'no' },
    ],
    field: 'financialReady',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- Ülke Seçim Bilinci --
  {
    id: 'target_country',
    section: 'country',
    text: 'Hangi ülkeyi hedefliyorsunuz?',
    type: 'choice',
    choices: [
      { label: 'Amerika Birleşik Devletleri', value: 'usa' },
      { label: 'Kanada', value: 'canada' },
      { label: 'Her ikisi de olabilir', value: 'both' },
    ],
    field: 'targetCountry',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'why_this_country',
    section: 'country',
    text: 'Bu ülkeyi neden tercih ediyorsunuz? Neden başka bir coğrafyayı değil?',
    type: 'textarea',
    field: 'whyThisCountry',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'country_research',
    section: 'country',
    text: 'Hedef ülke hakkında nasıl bir araştırma yaptınız? (Yaşam maliyetleri, iklim, sağlık sistemi vb.)',
    type: 'textarea',
    field: 'countryResearch',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'country_concerns',
    section: 'country',
    text: 'O ülkede sizi en çok endişelendiren şey ne? Bu zorluğu nasıl aşmayı planlıyorsunuz?',
    type: 'textarea',
    field: 'countryConcerns',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'target_state',
    section: 'country',
    text: 'Yerleşmeyi hedeflediğiniz bir eyalet veya şehir var mı? Varsa hangisi?',
    type: 'text',
    field: 'targetState',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- İşveren Perspektifi --
  {
    id: 'employer_question',
    section: 'employer',
    text: 'Eğer size sponsor olmayı düşünen şirketin işvereni siz olsaydınız, kendinizi işe alır mıydınız? İşverenin en büyük çekincesi ne olabilir?',
    type: 'textarea',
    field: 'employerQuestion',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'value_proposition',
    section: 'employer',
    text: 'Sponsorunuza "Bu yatırıma kesinlikle değdi" dedirtecek en belirgin özelliğiniz nedir?',
    type: 'textarea',
    field: 'valueProposition',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'team_approach',
    section: 'employer',
    text: 'Yabancı bir ülkede yeni bir şirkette işe başladığınızda, ilk haftalarda nasıl bir yaklaşım sergilersiniz?',
    type: 'textarea',
    field: 'teamApproach',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- Kültürel Uyum ve Esneklik --
  {
    id: 'overseas_experience',
    section: 'adaptation',
    text: 'Daha önce yurt dışında bulundunuz mu? Hangi ülkelerde, ne amaçla?',
    type: 'textarea',
    field: 'overseasExperience',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'lower_position',
    section: 'adaptation',
    text: 'Yeni ülkede ilk etapta kendi seviyenizin altında bir pozisyonda başlamanız gerekebilir. Bu durumla nasıl başa çıkarsınız?',
    type: 'choice',
    choices: [
      { label: 'Kabul ederim, zaman içinde yükselmek isterim', value: 'accept' },
      { label: 'Zor olur ama denerim', value: 'try' },
      { label: 'Kendi seviyemden aşağıda başlamam zor', value: 'difficult' },
    ],
    field: 'lowerPosition',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'young_manager',
    section: 'adaptation',
    text: 'Sizden yaşça küçük bir yönetici tarafından denetlenmeniz durumunda nasıl bir tavır sergilersiniz?',
    type: 'choice',
    choices: [
      { label: 'Profesyonel karşılar, işime odaklanırım', value: 'professional' },
      { label: 'Alışmam biraz zaman alır', value: 'adjust' },
      { label: 'Zor bir durum olur benim için', value: 'difficult' },
    ],
    field: 'youngManager',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'culture_shock',
    section: 'adaptation',
    text: 'Kültür şoku ve yalnızlık hissiyle başa çıkmak için nasıl bir stratejiniz var?',
    type: 'textarea',
    field: 'cultureShock',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'contract_commitment',
    section: 'adaptation',
    text: 'Sponsorluk karşılığında minimum 2 yıl çalışma taahhüdünü kabul ediyor musunuz?',
    type: 'choice',
    choices: [
      { label: 'Evet, kabul ediyorum', value: 'yes' },
      { label: 'Süreye bağlı, görüşmek isterim', value: 'discuss' },
      { label: 'Hayır, taahhüt vermek istemiyorum', value: 'no' },
    ],
    field: 'contractCommitment',
    condition: (a) => a.abroadInterest === 'yes',
  },

  // -- Sertifika ve Oturum --
  {
    id: 'diploma_equivalency',
    section: 'certification',
    text: 'Diplomanızın yurt dışında denklik durumuna dair bir araştırma yaptınız mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, araştırdım', value: 'yes' },
      { label: 'Hayır, henüz yapmadım', value: 'no' },
    ],
    field: 'diplomaEquivalency',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'diploma_detail',
    section: 'certification',
    text: 'Denklik araştırmanızın sonuçlarını kısaca paylaşır mısınız?',
    type: 'textarea',
    field: 'diplomaDetail',
    condition: (a) => a.abroadInterest === 'yes' && a.diplomaEquivalency === 'yes',
  },
  {
    id: 'cert_willingness',
    section: 'certification',
    text: 'Kuzey Amerika standartlarında mesleki sertifikasyon sürecine (Red Seal, CDL, OSHA vb.) girmeye istekli misiniz?',
    type: 'choice',
    choices: [
      { label: 'Çok istekliyim, hemen başlayabilirim', value: 'very' },
      { label: 'İstekliyim, bilgi isterim', value: 'willing' },
      { label: 'Emin değilim', value: 'unsure' },
    ],
    field: 'certWillingness',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'na_driver_license',
    section: 'certification',
    text: 'Kuzey Amerika\'da geçerli sürücü belgesi almaya hazır mısınız?',
    type: 'choice',
    choices: [
      { label: 'Evet, hazırım', value: 'yes' },
      { label: 'Bilgi almak istiyorum', value: 'info' },
      { label: 'Sürücü belgesi gerekmiyor', value: 'notneeded' },
    ],
    field: 'naDriverLicense',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'safety_english',
    section: 'certification',
    text: 'Sahada güvenlik talimatlarını İngilizce olarak anlayıp uygulayabilir misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, anlayabilirim', value: 'yes' },
      { label: 'Kısmen, temel düzeyde', value: 'partial' },
      { label: 'Hayır, desteğe ihtiyacım var', value: 'no' },
    ],
    field: 'safetyEnglish',
    condition: (a) => a.abroadInterest === 'yes' && a.englishLevel && a.englishLevel !== 'fluent' && a.englishLevel !== 'advanced',
  },
];

// Tüm soruları döndür (tek akış)
export function buildFlow() {
  return [...QUESTIONS];
}

// Koşullu soruları filtrele
export function getActiveQuestions(flow, answers) {
  return flow.filter(q => {
    if (!q.condition) return true;
    return q.condition(answers);
  });
}

// İlerleme yüzdesini hesapla
export function getProgress(currentIndex, totalQuestions) {
  if (totalQuestions <= 0) return 0;
  return Math.round((currentIndex / totalQuestions) * 100);
}

// Mevcut bölümü bul
export function getCurrentSection(questionId) {
  const q = QUESTIONS.find(qu => qu.id === questionId);
  if (!q) return null;
  return SECTIONS.find(s => s.id === q.section);
}

// Bölüm değişip değişmediğini kontrol et
export function didSectionChange(prevQuestionId, currentQuestionId) {
  const prevSection = getCurrentSection(prevQuestionId);
  const currSection = getCurrentSection(currentQuestionId);
  if (!prevSection || !currSection) return false;
  return prevSection.id !== currSection.id;
}

// CV fazı bitip bitmediğini kontrol et (cv_name cevaplandı mı)
export function isCvPhaseComplete(answers) {
  return !!answers.cvName;
}

// Tamamen bitti mi (abroad hayır veya tüm sorular bitti)
export function isFlowComplete(answers, flow) {
  if (answers.abroadInterest === 'no') return true;
  const active = getActiveQuestions(flow, answers);
  const lastQ = active[active.length - 1];
  return lastQ && !!answers[lastQ.field];
}

export default QUESTIONS;
